import { render, staticRenderFns } from "./ContratosClient.vue?vue&type=template&id=33bd9bca&"
import script from "./ContratosClient.vue?vue&type=script&lang=js&"
export * from "./ContratosClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports